import Reveal from "@/components/Reveal";
import { PLAYLIST } from "@/constants/testIds";
import { Play } from "lucide-react";

const playlists = [
  { title: "Morning Pages", mood: "Ambient · Instrumental", tone: "#c9d3d8" },
  { title: "Long Drives", mood: "Indie · Folk", tone: "#8a867e" },
  { title: "The Hour Before", mood: "Piano · Meditative", tone: "#1a2028" },
  { title: "In Motion", mood: "House · Focus", tone: "#5c664d" },
];

export default function Playlist() {
  return (
    <section
      id="playlist"
      data-testid={PLAYLIST.root}
      className="relative text-[#e8ecef] py-32 md:py-48 overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, #0a0e14 0%, #0a0e14 40%, #0a0e14 60%, #1a3a44 100%)",
      }}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-20 md:mb-28">
          <div>
            <Reveal>
              <p className="text-[11px] tracking-[0.38em] uppercase text-[#8a9498] mb-8">
                (05) — The Playlist
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
                A soundtrack for<br />
                <span className="font-light text-[#8a9498]">
                  intentional living.
                </span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-[#8a9498] max-w-sm font-light leading-relaxed">
              Curated for the quiet moments — mornings, movement, and the slow
              hour before rest. Spotify integration arrives soon.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {playlists.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06}>
              <div
                data-testid={PLAYLIST.card(i)}
                className="group relative aspect-square overflow-hidden cursor-not-allowed"
                style={{ backgroundColor: p.tone }}
              >
                <div className="absolute inset-0 opacity-30 mix-blend-overlay bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.6),transparent_40%),radial-gradient(circle_at_70%_80%,rgba(0,0,0,0.4),transparent_40%)]" />
                <div className="absolute inset-0 flex flex-col justify-between p-5 md:p-7">
                  <div className="flex items-start justify-between">
                    <span className="text-[10px] tracking-[0.32em] uppercase text-white/85">
                      Vol. {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="bg-[#0b0a08]/70 backdrop-blur px-2.5 py-1 text-[9px] tracking-[0.28em] uppercase text-[#e8ecef]">
                      Soon
                    </span>
                  </div>
                  <div>
                    <div className="mb-4 w-11 h-11 rounded-full bg-[#e8ecef] flex items-center justify-center transition-transform duration-500 group-hover:scale-110">
                      <Play size={16} className="text-[#0a0a0a] translate-x-[1px]" fill="currentColor" />
                    </div>
                    <h3 className="font-serif text-xl md:text-2xl leading-tight tracking-tight text-white">
                      {p.title}
                    </h3>
                    <p className="mt-1 text-[11px] tracking-[0.2em] uppercase text-white/75">
                      {p.mood}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
